import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { iconInfo } from 'client/images/inline-svgs/ads/cpo-icons';

import './disclaimer.scss';

const Styles = {
  button: {
    fontWeight: 'normal',
    fontSize: '0.625rem',
    lineHeight: '1.5rem',
    letterSpacing: 0,
    textAlign: 'right',
    padding: '0 4px',
    textTransform: 'capitalize',
    zIndex: 1,
  },
};

export function Disclaimer({
  ariaLabel = '',
  linkDisclaimer = 'Disclaimer',
  disclaimerText = '',
  contentClasses = 'p-1',
  openTrackingId = '',
  closeTrackingId = '',
  translateY = 101,
  buttonStyle = {},
  buttonClasses = 'text-gray-darker',
  tabIndex = 0,
  useHeading = false,
  useIconInfo = false,
}) {
  const contentRef = useRef();
  const [isHidden, toggleHidden] = useToggle(true);

  useEffect(() => {
    contentRef?.current?.container
      ?.querySelectorAll('a')
      .forEach(element => element.setAttribute('tabindex', isHidden ? -1 : 0));
  }, [isHidden]);

  return (
    <Fragment>
      <Button
        className={classnames('disclaimer-button disclaimer', buttonClasses)}
        style={{ ...Styles.button, ...buttonStyle }}
        color="link"
        onClick={toggleHidden}
        data-tracking-id={openTrackingId}
        aria-label={ariaLabel || `View ${linkDisclaimer}`}
        tabIndex={tabIndex}
      >
        {linkDisclaimer && linkDisclaimer}
        {useIconInfo && iconInfo}
      </Button>
      <div
        className={classnames(`disclaimer-content text-start`, contentClasses, {
          show: !isHidden,
        })}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          transform: `translateY(${translateY}%)`,
        }}
      >
        <button
          className="disclaimer-close border-0 p-0_25 m-0_5 icon-cancel-circle2 text-gray pos-a top-0 right-0"
          onClick={toggleHidden}
          data-tracking-id={closeTrackingId}
          disabled={isHidden}
          aria-label={`Close ${linkDisclaimer}`}
          tabIndex={tabIndex}
        />
        {useHeading && <div className="text-gray-darker size-14 fw-bold">Disclaimer</div>}
        <ContentFragment ref={contentRef} classes="text-gray-darker size-12 pe-0_75 h-100 overflow-auto">
          {disclaimerText}
        </ContentFragment>
      </div>
    </Fragment>
  );
}

Disclaimer.propTypes = {
  ariaLabel: PropTypes.string,
  linkDisclaimer: PropTypes.string,
  disclaimerText: PropTypes.string,
  contentClasses: PropTypes.string,
  openTrackingId: PropTypes.string,
  closeTrackingId: PropTypes.string,
  translateY: PropTypes.number,
  absoluteBottomValue: PropTypes.string,
  buttonStyle: PropTypes.shape({}),
  buttonClasses: PropTypes.string,
  tabIndex: PropTypes.number,
  useHeading: PropTypes.bool,
  useIconInfo: PropTypes.bool,
};
